import $ from 'jquery';
import AbstractCreditCardGateway from './AbstractCreditCardGateway';

class CustomCreditCard extends AbstractCreditCardGateway {

    selector = '#wc-stripe-cc-custom-form';

    _elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid'
    }

    shouldMountElement(container) {
        return $('#wc-stripe-cc-custom-form').find('iframe').length === 0;
    }

    createPaymentElement() {
        const options = {
            classes: this._elementClasses,
            ...this.settings.cardFormOptions
        }
        this.cardNumber = this.elements.create('cardNumber', {...this.settings.customFieldOptions.cardNumber, ...options});
        this.cardExpiry = this.elements.create('cardExpiry', {...this.settings.customFieldOptions.cardExpiry, ...options});
        this.cardCvc = this.elements.create('cardCvc', {...this.settings.customFieldOptions.cardCvc, ...options});

        this.cardNumber.on('change', this.onCardNumberChange.bind(this));

        // Set this to true so createPaymentElement isn't called again.
        this.paymentElement = true;
    }

    async mountPaymentElement(container) {
        this.cardNumber.mount('#stripe-card-number');
        this.cardExpiry.mount('#stripe-exp');
        this.cardCvc.mount('#stripe-cvv');

        $('#stripe-card-number').prepend(this.settings.html.card_brand);

        if ($('#stripe-postal-code').length) {
            $('#stripe-postal-code').on('focus', (e) => {
                $('#stripe-postal-code').addClass('focused');
            });
            $('#stripe-postal-code').on('blur', (e) => {
                $('#stripe-postal-code').removeClass('focused').trigger('keyup');
            });
            $('#stripe-postal-code').on('keyup', (e) => {
                if ($('#stripe-postal-code').val() === '') {
                    $('#stripe-postal-code').addClass('empty');
                } else {
                    $('#stripe-postal-code').removeClass('empty');
                }
            });
        }
    }

    onCardNumberChange(event) {
        if (event.brand === "unknown") {
            $('#wc-stripe-card').removeClass('active');
        } else {
            $('#wc-stripe-card').addClass('active');
        }
        $('#wc-stripe-card').attr('src', this.settings.cardIcons[event.brand]);
    }

    async createPaymentMethod() {
        try {
            const billingDetails = this.getBillingDetails();
            const response = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.cardNumber,
                /**
                 * If this is not the checkout page, we just pass the postal_code for the address object.
                 */
                billing_details: this.context.isCheckout() ? {
                    ...billingDetails,
                    ...($('#stripe-postal-code').length && {
                        address: {
                            ...billingDetails.address,
                            postal_code: $('#stripe-postal-code').val(),
                        }
                    })
                } : {
                    ...billingDetails,
                    address: {
                        ...($('#stripe-postal-code').length && {
                            postal_code: $('#stripe-postal-code').val(),
                        })
                    }
                }
            });
            if (response.error) {
                throw response.error;
            }
            this.setPaymentMethodId(response.paymentMethod.id);
        } catch (error) {
            throw error;
        }
    }

    async confirmPayment(data, options = {}) {
        return this.stripe.confirmCardPayment(data.client_secret);
    }

    async confirmSetup(data, options = {}) {
        return this.stripe.confirmCardSetup(data.client_secret);
    }
}

export default CustomCreditCard;